import {DahPaginationModel, PageableResponse} from '@common/models/commonHTTP.models';

export const MESSENGER_MAX_PAGES_COUNT = 3;

export interface MessagesPaginationModel extends DahPaginationModel {
    firstNumber: number;
    lastNumber: number;
}

export interface MessengerGroup {
    admin?: boolean,
    adminUserId?: string;
    canWriteMessage?: boolean;
    accessDenied?: AccessDeniedModel;
    id?: string;
    interlocutorId?: string;
    lastMessage?: MessageModel<any>;
    logoLink?: string;
    lto?: number;
    associationId?: string;
    online?: boolean;
    membersCount?: number;
    name?: string;
    notificationEnabled?: boolean;
    ownerId?: string;
    ownerType?: 'ASSOCIATION' | 'BUILDING';
    totalUnread?: number;
    type?: MessengerGroupType;
    updated?: number,

    selfDeliveredMessageIndex?: number;
    selfViewedMessageIndex?: number;

    lastMessageIndex?: number;
    lastSentMessageIndex?: number;
    lastViewedMessageIndex?: number;

    showHistory?: boolean;
}

export type MessengerGroupType = 'PERSONAL' | 'SYSTEM' | 'CUSTOM' | 'PUBLIC';

export interface MessageModel<T> {
    id: string;
    payload?: T;
    createTime?: number;
    editTime?: number;
    groupId?: string;
    groupLogoLink?: string;
    groupType?: MessengerGroupType;
    groupName?: string;
    index?: number;
    liked?: boolean;
    likesCount?: number;
    replyTo?: MessageModel<any>;
    senderAvatarLink?: string;
    senderFirstName?: string;
    senderLastName?: string;
    senderUpdateTime?: number;
    senderUserId?: string;
    serverReceiveTime?: number;
    status?: MessageStatus;
    type?: MessageType
}

export type MessageStatus = 'FORMED' | 'SENT' | 'DELIVERED' | 'VIEWED' | 'REMOVED';
export type MessageType = 'TEXT' | 'PHOTO' | 'FILE' | 'POST' | 'SYSTEM';
export type SystemMessageActionType = 'MEMBER_ADDED' | 'MEMBER_DELETED' | 'SETTINGS_CHANGED';

export interface MessageSystemPayload {
    data: {
        userId: string
    };
    type: SystemMessageActionType;
}

export interface MessageFilePayload {
    Link: string;
    Name: string;
    Size: number;
    Type: string;
    Description?: string;
    Progress?: null
}

export interface MessagePhotoPayload {
    Code: string;
    Description?: string;
    Format?: string;
    Height: number;
    Width: number
}

export interface SendMessageRequest {
    createTime: number;
    groupId: string;
    payload: string | MessageSystemPayload | MessageFilePayload | MessagePhotoPayload;
    type: MessageType
    replyToMessageId?: string;
}

export interface MessageDetailsResponse {
    likesCount: number;
    members: PageableResponse<MessageViewerResponse>;
    totalCount: number;
    viewersCount: number
}

export interface MessageViewerResponse {
    avatarLink?: string;
    firstName?: string;
    lastName?: string;
    liked?: boolean;
    paternalName?: string;
    shortName?: string;
    updateTime?: number;
    userId?: string;
    viewDateTime?: number;
}

export interface GroupAdminsModel {
    groupId: string;
    mainAdmin: GroupMemberModel
    admins: GroupMemberModel[];
}

export interface AdminPermissions {
    addGroupMembers?: boolean,
    deleteGroupMembers?: boolean,
    deleteMessages?: boolean,
    manageAccessToWrite?: boolean,
    manageAdmins?: boolean,
    manageGroup?: boolean
}

export interface GroupMemberDenyAccess {
    dateTime?: string,
    type?: 'HOUR' | 'DAY' | 'WEEK' | 'DATE_TIME';
}

export interface GroupMemberModel {
    accessDenied?: AccessDeniedModel;
    admin?: boolean;
    adminPermissions?: AdminPermissionsModel;
    avatarLink?: string;
    commonAddGroupMembers?: boolean;
    firstName?: string;
    government?: boolean;
    hasApartment?: boolean;
    lastName?: string;
    line2?: string;
    paternalName?: string;
    shortName?: string;
    status?: "DELETED" | "ACTIVE";
    updateTime?: number;
    userId?: string;
}

export interface AccessDeniedModel {
    bySettings?: boolean;
    dateTime?: string;
    userFirstName?: string;
    userId?: string;
    userLastName?: string;
    userPaternalName?: string;
}

export interface AdminPermissionsModel {
    addGroupMembers?: boolean;
    deleteGroupMembers?: boolean;
    deleteMessages?: boolean;
    manageAccessToWrite?: boolean;
    manageAdmins?: boolean;
    manageGroup?: boolean;
}

export interface MessageStatusWsModel {
    groupId: string;
    index: number;
    selfDeliveredMessageIndex: number;
    selfViewedMessageIndex: number;
    status: MessageStatus;
    totalUnread?: number
}

export interface MessageLikesResponse {
    likes: number;
    liked: boolean;
}

export interface GroupMembersChangedWsModel {
    groupId: string;
    membersCount: number;
    status: 'DELETED' | 'ACTIVE';
    userIds: string[];
}

export type MediaFileType = 'media' | 'files';

// від сервера приходить FileResponse, але уже є FileResponse, тимчасово створено цей до рефакторингу || MessageModel
export interface MediaFileResponse<T> {
    createTime?: number,
    groupId?: string,
    id: string,
    payload?: T,
    senderAvatarLink?: string,
    senderFirstName?: string,
    senderLastName?: string,
    senderUserId?: string,
    serverReceiveTime?: string
}
